module.exports = __webpack_public_path__ + "static/media/chevron-right.b173af21.svg";